import React from 'react';

import { KeyOutlined, LockOutlined } from '@ant-design/icons';
import { Form, Input, Alert, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const MoPlusCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();
  const serverIp = document.querySelector('meta[name="server-ip"]')?.content || '';

  const isEditing = !!ecAccount?.id;
  const accessTokenDirty = useDirtyMaskedField(form, [ 'credentials', 'access_token' ], isEditing);
  const pdfPasswordDirty = useDirtyMaskedField(form, [ 'credentials', 'pdf_password' ], isEditing);

  return (
    <div>
      <Alert
        message={`${t('models.ec_account.platform_settings.mo_plus.ip_whitelist_warning')} IP: ${serverIp}`}
        type="warning"
        showIcon
        style={{ marginBottom: '16px' }}
      />

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'access_token']}
            label={t('models.ec_account.platform_settings.mo_plus.token')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.mo_plus.token_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.mo_plus.token_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={accessTokenDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'pdf_password']}
            label={t('models.ec_account.platform_settings.mo_plus.pdf_password')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.mo_plus.pdf_password_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.mo_plus.pdf_password_placeholder')}
              prefix={<LockOutlined />}
              visibilityToggle={pdfPasswordDirty}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default MoPlusCredentials;
